import type { BanDich } from '../../types';
import type { viChung } from './chung.vi';

export const enChung: Pick<BanDich, keyof typeof viChung> = {
  troLyAi: {
    xemCheoTieuDe: "You're viewing the tenant interface",
    xemCheoMo: "AI Assistant runs on one organization's data. Sign in with an organization account to see real data.",
    chuaSanSangTieuDe: 'AI Assistant is not ready',
    chuaSanSangMo: "The AI Assistant module isn't running on this server yet. Try again later or contact the operations team.",
    tuChoiTieuDe: 'Query blocked',
    lamMoi: 'Refresh',
    dong: '{{so}} rows',
    luoiNguon: {
      timNguon: 'Search sources by name, code or description',
      moiLoai: 'All source types',
      loaiCsdl: 'Database',
      loaiGraphql: 'GraphQL',
      loaiApi: 'API',
      loaiCsdlVaGraphql: 'Database / GraphQL',
      demNguon: '{{shown}}/{{total}} sources',
      rongTieuDe: 'No sources yet',
      rongMoTa: 'Add a source in Source connections first, then come back here.',
      sangKetNoi: 'Go to Source connections',
      khongKhopTieuDe: 'No sources match',
      danhSachNguon: 'Data source list',
    },
    trangThaiNguon: {
      draft: 'Draft',
      connected: 'Connected',
      ready: 'Ready',
      error: 'Error',
    },
    kieuHien: {
      nhan: 'Display mode',
      luoi: 'Grid',
      danhSach: 'List',
    },
  },
};
